import Alpine from 'alpinejs';
import { createLottieAnimation } from './_lottie';

const CARD_STAGGER_MS = 140;
const CARD_FADE_MS = 500;

Alpine.data('contentHub', (initialData) => ({
    pods: initialData.pods,
    animations: initialData.animations || {},
    isStirring: false,
    cardsAnimating: false,
    fadingPods: [],
    showClick: false,
    hoverAnimation: null,
    clickAnimation: null,

    init() {
        this.fadingPods = this.pods.map(() => false);

        if (this.$refs.stirHover && this.animations.hover) {
            this.hoverAnimation = createLottieAnimation(this.$refs.stirHover, {
                path: this.animations.hover,
                loop: true,
                autoplay: false,
            });
        }

        if (this.$refs.stirClick && this.animations.click) {
            this.clickAnimation = createLottieAnimation(this.$refs.stirClick, {
                path: this.animations.click,
                loop: false,
                autoplay: false,
            });

            this.clickAnimation.addEventListener('complete', () => {
                this.showClick = false;
                this.clickAnimation?.goToAndStop(0, true);
                this.finishStir('click');
            });
        }
    },

    destroy() {
        this.hoverAnimation?.destroy();
        this.clickAnimation?.destroy();
        this.hoverAnimation = null;
        this.clickAnimation = null;
    },

    onStirHover() {
        if (this.isStirring) return;
        this.showClick = false;
        this.hoverAnimation?.goToAndPlay(0, true);
    },

    onStirLeave() {
        if (this.isStirring) return;
        this.hoverAnimation?.goToAndStop(0, true);
    },

    finishStir(source) {
        if (source === 'cards') {
            this.cardsAnimating = false;
        }

        if (source === 'click' || !this.clickAnimation) {
            this.showClick = false;
        }

        if (!this.cardsAnimating && (!this.showClick || !this.clickAnimation)) {
            this.isStirring = false;
        }
    },

    async stir() {
        if (this.isStirring) return;

        this.isStirring = true;
        this.cardsAnimating = true;
        this.showClick = true;
        this.hoverAnimation?.goToAndStop(0, true);
        this.clickAnimation?.goToAndPlay(0, true);

        const count = this.pods.length;

        for (let i = 0; i < count; i++) {
            this.fadingPods = this.fadingPods.map((fading, index) =>
                index === i ? true : fading
            );
            await this.wait(CARD_STAGGER_MS);
        }

        await this.wait(CARD_FADE_MS);

        this.pods.forEach((pod) => {
            if (pod.items.length > 1) {
                let newIndex;
                const poolSize = pod.items.length;
                do {
                    newIndex = Math.floor(Math.random() * poolSize);
                } while (newIndex === pod.activeIndex);
                pod.activeIndex = newIndex;
            }
        });

        this.pods = this.shuffleArray([...this.pods]);

        for (let i = 0; i < count; i++) {
            this.fadingPods = this.fadingPods.map((fading, index) =>
                index === i ? false : fading
            );
            await this.wait(CARD_STAGGER_MS);
        }

        await this.wait(CARD_FADE_MS);
        this.finishStir('cards');
    },

    wait(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },

    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    },
}));
